// Персонал — отдельный раздел с QR-карточками для печати
import React, { useState, useEffect, useCallback } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { logoPng } from '../../config/assets';

// QR должен вести на тот же origin, с которого печатают карточки (иначе прод-сборка с устаревшим REACT_APP_* ломает вход)
function clientPublicOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin.replace(/\/$/, '');
  return (process.env.REACT_APP_CLIENT_URL || '').replace(/\/$/, '');
}
const DOMAIN = 'tez-hop.uz';
const LOGO_URL = logoPng();

// 🤵🏻 мужчина / 👩🏻‍💼 женщина
const genderEmoji = (g) => (g === 'female' ? '👩🏻‍💼' : '🤵🏻');

function WaiterQRCard({ waiter, restaurantName }) {
  const base = clientPublicOrigin();
  const url = `${base}/waiter-login?token=${encodeURIComponent(waiter.waiter_token || '')}`;
  const displayName = waiter.name || waiter.email;
  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '280px',
      }}
    >
      <div style={{ backgroundColor: '#111', padding: '14px 16px', textAlign: 'center' }}>
        <div style={{ color: '#AAA', fontSize: '11px', marginBottom: '4px' }}>{restaurantName}</div>
        <div style={{ fontSize: '28px', marginBottom: '4px' }}>{genderEmoji(waiter.gender)}</div>
        <div style={{ color: '#fff', fontWeight: '700', fontSize: '18px' }}>{displayName}</div>
        <div style={{ color: '#888', fontSize: '12px', marginTop: '2px' }}>Вход в панель заказов</div>
      </div>
      <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', backgroundColor: '#fff' }}>
        <QRCodeSVG value={url} size={160} bgColor="#FFFFFF" fgColor="#111111" level="M" includeMargin={false} />
      </div>
      <div
        style={{
          backgroundColor: '#F7F7F7',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          borderTop: '1px solid #EFEFEF',
        }}
      >
        <img
          src={typeof window !== 'undefined' ? window.location.origin + LOGO_URL : LOGO_URL}
          alt=""
          style={{ width: 32, height: 32, objectFit: 'contain' }}
        />
        <span style={{ fontSize: '12px', fontWeight: '600', color: '#333', fontFamily: "'Comfortaa', -apple-system, sans-serif" }}>{DOMAIN}</span>
      </div>
    </div>
  );
}

/** Общий QR на /login — у курьера нет waiter_token; вход email+пароль, дальше редирект на /courier */
function CourierLoginQRCard({ restaurantName }) {
  const base = clientPublicOrigin();
  const url = `${base}/login?hint=courier`;
  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '280px',
      }}
    >
      <div style={{ backgroundColor: '#1B5E20', padding: '14px 16px', textAlign: 'center' }}>
        <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '11px', marginBottom: '4px' }}>{restaurantName}</div>
        <div style={{ fontSize: '28px', marginBottom: '4px' }}>🚗</div>
        <div style={{ color: '#fff', fontWeight: '700', fontSize: '16px' }}>Курьер</div>
        <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px', marginTop: '4px' }}>Вход по email и паролю</div>
      </div>
      <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', backgroundColor: '#fff' }}>
        <QRCodeSVG value={url} size={160} bgColor="#FFFFFF" fgColor="#111111" level="M" includeMargin={false} />
      </div>
      <div
        style={{
          backgroundColor: '#F7F7F7',
          padding: '10px 12px',
          textAlign: 'center',
          fontSize: '11px',
          color: '#666',
          borderTop: '1px solid #EFEFEF',
        }}
      >
        Скан → <code style={{ fontSize: '10px' }}>/login?hint=courier</code> → панель курьера
      </div>
    </div>
  );
}

export default function StaffTab({ api, restaurantId, restaurant }) {
  const [waiters, setWaiters] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [showAddCourier, setShowAddCourier] = useState(false);
  const [editId, setEditId] = useState(null);
  const [newWaiter, setNewWaiter] = useState({ email: '', password: '', name: '', gender: 'male' });
  const [newCourier, setNewCourier] = useState({ email: '', password: '', name: '', phone: '' });
  const [editData, setEditData] = useState({ email: '', name: '', gender: 'male', password: '' });
  const [editCourierId, setEditCourierId] = useState(null);
  const [editCourierData, setEditCourierData] = useState({ email: '', name: '', phone: '', password: '' });
  const [kitchenStaff, setKitchenStaff] = useState([]);
  const [showAddKitchen, setShowAddKitchen] = useState(false);
  const [newKitchen, setNewKitchen] = useState({ email: '', password: '', name: '' });

  const showMsg = (m) => {
    setMessage(m);
    setTimeout(() => setMessage(''), 3000);
  };

  const fetchWaiters = useCallback(async () => {
    if (!restaurantId || !api) return;
    try {
      const { data } = await api.get(`/api/staff/waiters?restaurantId=${restaurantId}`);
      setWaiters(data.waiters || []);
    } catch (err) {
      console.error('fetchWaiters:', err);
    }
  }, [api, restaurantId]);

  const fetchCouriers = useCallback(async () => {
    if (!restaurantId || !api) return;
    try {
      const { data } = await api.get(`/api/staff/couriers`, {
        params: { restaurantId },
      });
      setCouriers(data.couriers || []);
    } catch (err) {
      console.error('fetchCouriers:', err);
    }
  }, [api, restaurantId]);

  const fetchKitchen = useCallback(async () => {
    if (!restaurantId || !api) return;
    try {
      const { data } = await api.get(`/api/staff/kitchen-staff`, {
        params: { restaurantId },
      });
      setKitchenStaff(data.kitchen || []);
    } catch (err) {
      console.error('fetchKitchen:', err);
    }
  }, [api, restaurantId]);

  useEffect(() => {
    fetchWaiters();
  }, [fetchWaiters]);

  useEffect(() => {
    fetchCouriers();
  }, [fetchCouriers]);

  useEffect(() => {
    fetchKitchen();
  }, [fetchKitchen]);

  const handleCreate = async () => {
    if (!newWaiter.email?.trim() || !newWaiter.password) {
      showMsg('❌ Заполните email и пароль');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/staff/waiters', {
        ...newWaiter,
        restaurant_id: restaurantId,
        name: newWaiter.name?.trim() || null,
      });
      setNewWaiter({ email: '', password: '', name: '', gender: 'male' });
      setShowAdd(false);
      showMsg('✅ Официант добавлен');
      fetchWaiters();
    } catch (err) {
      showMsg(err.response?.data?.error || '❌ Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (w) => {
    setEditCourierId(null);
    setEditId(w.id);
    setEditData({ email: w.email, name: w.name || '', gender: w.gender || 'male', password: '' });
  };

  const handleSaveEdit = async () => {
    if (!editData.email?.trim()) {
      showMsg('❌ Email обязателен');
      return;
    }
    setLoading(true);
    try {
      const body = {
        email: editData.email.trim(),
        name: editData.name.trim() || null,
        gender: editData.gender,
      };
      if (editData.password?.trim()) {
        body.password = editData.password;
      }
      await api.patch(`/api/staff/waiters/${editId}`, body);
      setEditId(null);
      setEditData({ email: '', name: '', gender: 'male', password: '' });
      showMsg('✅ Сохранено');
      fetchWaiters();
    } catch (err) {
      showMsg(err.response?.data?.error || '❌ Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleEditCourier = (c) => {
    setEditId(null);
    setEditCourierId(c.id);
    setEditCourierData({
      email: c.email,
      name: c.name || '',
      phone: c.phone || '',
      password: '',
    });
  };

  const handleSaveCourierEdit = async () => {
    if (!editCourierData.email?.trim()) {
      showMsg('❌ Email обязателен');
      return;
    }
    setLoading(true);
    try {
      const body = {
        email: editCourierData.email.trim(),
        name: editCourierData.name.trim() || null,
        phone: editCourierData.phone?.trim() || null,
      };
      if (editCourierData.password?.trim()) {
        body.password = editCourierData.password;
      }
      await api.patch(`/api/staff/couriers/${editCourierId}`, body);
      setEditCourierId(null);
      setEditCourierData({ email: '', name: '', phone: '', password: '' });
      showMsg('✅ Сохранено');
      fetchCouriers();
    } catch (err) {
      showMsg(err.response?.data?.error || '❌ Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить официанта?')) return;
    try {
      await api.delete(`/api/staff/waiters/${id}`);
      showMsg('✅ Удалено');
      fetchWaiters();
    } catch {
      showMsg('❌ Ошибка удаления');
    }
  };

  const handleCreateCourier = async () => {
    if (!newCourier.email?.trim() || !newCourier.password) {
      showMsg('❌ Заполните email и пароль');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/staff/couriers', {
        ...newCourier,
        restaurant_id: restaurantId,
        name: newCourier.name?.trim() || null,
        phone: newCourier.phone?.trim() || null,
      });
      setNewCourier({ email: '', password: '', name: '', phone: '' });
      setShowAddCourier(false);
      showMsg('✅ Курьер добавлен');
      fetchCouriers();
    } catch (err) {
      showMsg(err.response?.data?.error || '❌ Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCourier = async (id) => {
    if (!window.confirm('Удалить курьера?')) return;
    try {
      await api.delete(`/api/staff/couriers/${id}`);
      showMsg('✅ Удалено');
      fetchCouriers();
    } catch {
      showMsg('❌ Ошибка удаления');
    }
  };

  const handleCreateKitchen = async () => {
    if (!newKitchen.email?.trim() || !newKitchen.password) {
      showMsg('❌ Заполните email и пароль');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/staff/kitchen-staff', {
        ...newKitchen,
        restaurant_id: restaurantId,
        name: newKitchen.name?.trim() || null,
      });
      setNewKitchen({ email: '', password: '', name: '' });
      setShowAddKitchen(false);
      showMsg('✅ Повар добавлен');
      fetchKitchen();
    } catch (err) {
      showMsg(err.response?.data?.error || '❌ Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteKitchen = async (id) => {
    if (!window.confirm('Удалить повара?')) return;
    try {
      await api.delete(`/api/staff/kitchen-staff/${id}`);
      showMsg('✅ Удалено');
      fetchKitchen();
    } catch {
      showMsg('❌ Ошибка удаления');
    }
  };

  const handleRegenerateToken = async (id) => {
    try {
      const { data } = await api.patch(`/api/staff/waiters/${id}/regenerate-token`);
      setWaiters((prev) => prev.map((w) => (w.id === id ? { ...w, waiter_token: data.waiter?.waiter_token } : w)));
      showMsg('✅ QR-токен обновлён');
    } catch {
      showMsg('❌ Ошибка');
    }
  };

  const handlePrint = () => {
    const el = document.getElementById('staff-print-area');
    if (!el) return;
    const win = window.open('', '_blank');
    win.document.write(
      `<!DOCTYPE html><html><head><title>QR-карточки</title>
      <style>body{font-family:-apple-system,sans-serif;padding:20px;margin:0}
      .cards{display:flex;flex-wrap:wrap;gap:24px;justify-content:center}
      .card{break-inside:avoid;page-break-inside:avoid}</style></head>
      <body><h2 style="text-align:center;margin-bottom:24px">QR-карточки: официанты и курьер</h2>
      <div class="cards">${el.innerHTML}</div></body></html>`
    );
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
      win.close();
    }, 500);
  };

  const restaurantName = restaurant?.name || 'Ресторан';

  const GenderSwitch = ({ value, onChange }) => (
    <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
      <button
        onClick={() => onChange('male')}
        style={{
          flex: 1,
          padding: '10px',
          borderRadius: '10px',
          border: '2px solid',
          borderColor: value === 'male' ? '#1565C0' : '#E0E0E0',
          backgroundColor: value === 'male' ? '#1565C0' : '#fff',
          color: value === 'male' ? '#fff' : '#333',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.15s ease',
        }}
      >
        🤵🏻 Мужчина
      </button>
      <button
        onClick={() => onChange('female')}
        style={{
          flex: 1,
          padding: '10px',
          borderRadius: '10px',
          border: '2px solid',
          borderColor: value === 'female' ? '#F48FB1' : '#E0E0E0',
          backgroundColor: value === 'female' ? '#FCE4EC' : '#fff',
          color: value === 'female' ? '#C2185B' : '#333',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.15s ease',
        }}
      >
        👩🏻‍💼 Женщина
      </button>
    </div>
  );

  return (
    <div style={{ fontFamily: '-apple-system, sans-serif' }}>
      {message && (
        <div
          style={{
            padding: '12px 16px',
            borderRadius: '12px',
            marginBottom: '16px',
            backgroundColor: message.startsWith('❌') ? '#FFEBEE' : '#E8F5E9',
            fontWeight: '500',
            textAlign: 'center',
            fontSize: '14px',
          }}
        >
          {message}
        </div>
      )}

      {/* ── Список официантов ── */}
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '16px',
          marginBottom: '20px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <div>
            <div style={{ fontWeight: '700', fontSize: '16px' }}>🤵🏻👩🏻‍💼 Официанты</div>
            <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>{restaurantName}</div>
          </div>
          {!showAdd && (
            <button onClick={() => setShowAdd(true)} style={btnStyle('#000')}>
              + Добавить
            </button>
          )}
        </div>

        {/* Форма добавления */}
        {showAdd && (
          <div
            style={{
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '12px',
              marginBottom: '16px',
              border: '1px solid #eee',
            }}
          >
            <div style={{ fontWeight: '600', marginBottom: '12px' }}>Новый сотрудник</div>
            <input
              style={inputStyle}
              placeholder="Имя (опционально)"
              value={newWaiter.name}
              onChange={(e) => setNewWaiter({ ...newWaiter, name: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Email *"
              type="email"
              value={newWaiter.email}
              onChange={(e) => setNewWaiter({ ...newWaiter, email: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Пароль *"
              type="password"
              value={newWaiter.password}
              onChange={(e) => setNewWaiter({ ...newWaiter, password: e.target.value })}
            />
            <GenderSwitch value={newWaiter.gender} onChange={(v) => setNewWaiter({ ...newWaiter, gender: v })} />
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <button onClick={handleCreate} disabled={loading} style={{ ...btnStyle('#000'), flex: 1, padding: '12px' }}>
                {loading ? '...' : '✅ Создать'}
              </button>
              <button
                onClick={() => {
                  setShowAdd(false);
                  setNewWaiter({ email: '', password: '', name: '', gender: 'male' });
                }}
                style={{
                  padding: '12px 16px',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: '#F0F0F0',
                  cursor: 'pointer',
                }}
              >
                Отмена
              </button>
            </div>
          </div>
        )}

        {waiters.length === 0 && !showAdd && (
          <div style={{ textAlign: 'center', color: '#999', padding: '24px', fontSize: '14px' }}>
            Нет официантов — добавьте первого
          </div>
        )}

        {waiters.map((w) => (
          <div key={w.id}>
            {editId === w.id ? (
              <div
                style={{
                  padding: '12px',
                  backgroundColor: '#F9F9F9',
                  borderRadius: '12px',
                  marginBottom: '8px',
                  border: '1px solid #eee',
                }}
              >
                <div style={{ fontWeight: '600', marginBottom: '10px', fontSize: '14px' }}>✏️ Редактировать</div>
                <input
                  style={inputStyle}
                  placeholder="Имя"
                  value={editData.name}
                  onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                />
                <input
                  style={{ ...inputStyle, marginTop: '8px' }}
                  placeholder="Email *"
                  type="email"
                  value={editData.email}
                  onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                />
                <GenderSwitch value={editData.gender} onChange={(v) => setEditData({ ...editData, gender: v })} />
                <input
                  style={{ ...inputStyle, marginTop: '8px' }}
                  placeholder="Новый пароль (если меняете)"
                  type="password"
                  autoComplete="new-password"
                  value={editData.password}
                  onChange={(e) => setEditData({ ...editData, password: e.target.value })}
                />
                <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                  <button
                    onClick={handleSaveEdit}
                    disabled={loading}
                    style={{ ...btnStyle('#000'), flex: 1, padding: '10px' }}
                  >
                    {loading ? '...' : '💾 Сохранить'}
                  </button>
                  <button
                    onClick={() => setEditId(null)}
                    style={{
                      padding: '10px 14px',
                      borderRadius: '10px',
                      border: 'none',
                      backgroundColor: '#F0F0F0',
                      cursor: 'pointer',
                    }}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '50%',
                      backgroundColor: '#F5F5F5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px',
                    }}
                  >
                    {genderEmoji(w.gender)}
                  </div>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>{w.name || w.email}</div>
                    <div style={{ fontSize: '12px', color: '#8E8E93' }}>
                      {w.name ? `${w.email} · ` : ''}с {new Date(w.created_at).toLocaleDateString('ru-RU')}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button
                    onClick={() => handleEdit(w)}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#E3F2FD',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    ✏️
                  </button>
                  {!w.waiter_token && (
                    <button
                      onClick={() => handleRegenerateToken(w.id)}
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#E8F5E9',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600',
                      }}
                    >
                      📱 QR
                    </button>
                  )}
                  <button
                    onClick={() => handleDelete(w.id)}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#FFEBEE',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ── Курьеры ── */}
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '16px',
          marginBottom: '20px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <div>
            <div style={{ fontWeight: '700', fontSize: '16px' }}>🚗 Курьеры</div>
            <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>
              Вход через /login — email и пароль
            </div>
          </div>
          {!showAddCourier && (
            <button onClick={() => setShowAddCourier(true)} style={btnStyle('#000')}>
              + Добавить
            </button>
          )}
        </div>

        {showAddCourier && (
          <div
            style={{
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '12px',
              marginBottom: '16px',
              border: '1px solid #eee',
            }}
          >
            <div style={{ fontWeight: '600', marginBottom: '12px' }}>Новый курьер</div>
            <input
              style={inputStyle}
              placeholder="Имя (опционально)"
              value={newCourier.name}
              onChange={(e) => setNewCourier({ ...newCourier, name: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Email *"
              type="email"
              value={newCourier.email}
              onChange={(e) => setNewCourier({ ...newCourier, email: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Пароль *"
              type="password"
              value={newCourier.password}
              onChange={(e) => setNewCourier({ ...newCourier, password: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Телефон (опционально)"
              type="tel"
              value={newCourier.phone}
              onChange={(e) => setNewCourier({ ...newCourier, phone: e.target.value })}
            />
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <button onClick={handleCreateCourier} disabled={loading} style={{ ...btnStyle('#000'), flex: 1, padding: '12px' }}>
                {loading ? '...' : '✅ Создать'}
              </button>
              <button
                onClick={() => {
                  setShowAddCourier(false);
                  setNewCourier({ email: '', password: '', name: '', phone: '' });
                }}
                style={{
                  padding: '12px 16px',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: '#F0F0F0',
                  cursor: 'pointer',
                }}
              >
                Отмена
              </button>
            </div>
          </div>
        )}

        {couriers.length === 0 && !showAddCourier && (
          <div style={{ textAlign: 'center', color: '#999', padding: '24px', fontSize: '14px' }}>
            Нет курьеров — добавьте первого
          </div>
        )}

        {couriers.map((c) => (
          <div key={c.id}>
            {editCourierId === c.id ? (
              <div
                style={{
                  padding: '12px',
                  backgroundColor: '#F9F9F9',
                  borderRadius: '12px',
                  marginBottom: '8px',
                  border: '1px solid #eee',
                }}
              >
                <div style={{ fontWeight: '600', marginBottom: '10px', fontSize: '14px' }}>✏️ Курьер</div>
                <input
                  style={inputStyle}
                  placeholder="Имя"
                  value={editCourierData.name}
                  onChange={(e) => setEditCourierData({ ...editCourierData, name: e.target.value })}
                />
                <input
                  style={{ ...inputStyle, marginTop: '8px' }}
                  placeholder="Email *"
                  type="email"
                  value={editCourierData.email}
                  onChange={(e) => setEditCourierData({ ...editCourierData, email: e.target.value })}
                />
                <input
                  style={{ ...inputStyle, marginTop: '8px' }}
                  placeholder="Телефон"
                  type="tel"
                  value={editCourierData.phone}
                  onChange={(e) => setEditCourierData({ ...editCourierData, phone: e.target.value })}
                />
                <input
                  style={{ ...inputStyle, marginTop: '8px' }}
                  placeholder="Новый пароль (если меняете)"
                  type="password"
                  autoComplete="new-password"
                  value={editCourierData.password}
                  onChange={(e) => setEditCourierData({ ...editCourierData, password: e.target.value })}
                />
                <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                  <button
                    onClick={handleSaveCourierEdit}
                    disabled={loading}
                    style={{ ...btnStyle('#1B5E20'), flex: 1, padding: '10px' }}
                  >
                    {loading ? '...' : '💾 Сохранить'}
                  </button>
                  <button
                    onClick={() => {
                      setEditCourierId(null);
                      setEditCourierData({ email: '', name: '', phone: '', password: '' });
                    }}
                    style={{
                      padding: '10px 14px',
                      borderRadius: '10px',
                      border: 'none',
                      backgroundColor: '#F0F0F0',
                      cursor: 'pointer',
                    }}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '50%',
                      backgroundColor: '#E8F5E9',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px',
                    }}
                  >
                    🚗
                  </div>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '14px' }}>{c.name || c.email}</div>
                    <div style={{ fontSize: '12px', color: '#8E8E93' }}>
                      {c.email}
                      {c.phone ? ` · ${c.phone}` : ''}
                      {' · '}с {new Date(c.created_at).toLocaleDateString('ru-RU')}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button
                    onClick={() => handleEditCourier(c)}
                    type="button"
                    style={{
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#E8F5E9',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDeleteCourier(c.id)}
                    type="button"
                    style={{
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#FFEBEE',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ── Кухня ── */}
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '16px',
          marginBottom: '20px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <div>
            <div style={{ fontWeight: '700', fontSize: '16px' }}>🍳 Кухня</div>
            <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>
              Вход через /kitchen — email и пароль
            </div>
          </div>
          {!showAddKitchen && (
            <button onClick={() => setShowAddKitchen(true)} style={btnStyle('#000')}>
              + Добавить
            </button>
          )}
        </div>

        {showAddKitchen && (
          <div
            style={{
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '12px',
              marginBottom: '16px',
              border: '1px solid #eee',
            }}
          >
            <div style={{ fontWeight: '600', marginBottom: '12px' }}>Новый повар</div>
            <input
              style={inputStyle}
              placeholder="Имя (опционально)"
              value={newKitchen.name}
              onChange={(e) => setNewKitchen({ ...newKitchen, name: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Email *"
              type="email"
              value={newKitchen.email}
              onChange={(e) => setNewKitchen({ ...newKitchen, email: e.target.value })}
            />
            <input
              style={{ ...inputStyle, marginTop: '8px' }}
              placeholder="Пароль *"
              type="password"
              value={newKitchen.password}
              onChange={(e) => setNewKitchen({ ...newKitchen, password: e.target.value })}
            />
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <button
                onClick={handleCreateKitchen}
                disabled={loading}
                style={{ ...btnStyle('#000'), flex: 1, padding: '12px' }}
              >
                {loading ? '...' : '✅ Создать'}
              </button>
              <button
                onClick={() => {
                  setShowAddKitchen(false);
                  setNewKitchen({ email: '', password: '', name: '' });
                }}
                style={{
                  padding: '12px 16px',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: '#F0F0F0',
                  cursor: 'pointer',
                }}
              >
                Отмена
              </button>
            </div>
          </div>
        )}

        {kitchenStaff.length === 0 && !showAddKitchen && (
          <div style={{ textAlign: 'center', color: '#999', padding: '24px', fontSize: '14px' }}>
            Нет поваров — добавьте первого
          </div>
        )}

        {kitchenStaff.map((k) => (
          <div
            key={k.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 0',
              borderBottom: '1px solid #f0f0f0',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  backgroundColor: '#FFF8E1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                }}
              >
                🍳
              </div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '14px' }}>{k.name || k.email}</div>
                <div style={{ fontSize: '12px', color: '#8E8E93' }}>
                  {k.email} · с {new Date(k.created_at).toLocaleDateString('ru-RU')}
                </div>
              </div>
            </div>
            <button
              onClick={() => handleDeleteKitchen(k.id)}
              style={{
                padding: '8px 12px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#FFEBEE',
                cursor: 'pointer',
                fontSize: '16px',
              }}
            >
              🗑️
            </button>
          </div>
        ))}
      </div>

      {/* ── QR-карточки ── */}
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '16px',
          marginBottom: '20px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <div>
            <div style={{ fontWeight: '700', fontSize: '16px' }}>📱 QR-карточки для входа</div>
            <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>
              Распечатайте и выдайте каждому сотруднику
            </div>
            <p style={{ fontSize: '12px', color: '#666', lineHeight: 1.5, marginTop: '10px', marginBottom: 0 }}>
              <strong>Официант</strong> — у каждого свой QR с токеном: по ссылке открывается <code style={{ fontSize: '11px' }}>waiter-login?token=…</code>, сервер выдаёт сессию{' '}
              <strong>без пароля</strong>. <strong>Курьер</strong> — отдельного токена в системе нет, только email и пароль на странице входа (общий QR ниже).
            </p>
          </div>
          <button onClick={handlePrint} type="button" style={btnStyle('#7B1FA2')}>
            🖨️ Печать
          </button>
        </div>

        <div
          id="staff-print-area"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '16px',
          }}
        >
          {waiters
            .filter((w) => w.waiter_token)
            .map((w) => (
              <div key={w.id} style={{ display: 'flex', justifyContent: 'center' }}>
                <WaiterQRCard waiter={w} restaurantName={restaurantName} />
              </div>
            ))}
          <div
            style={{
              gridColumn: '1 / -1',
              borderTop: '1px solid #EFEFEF',
              marginTop: '4px',
              paddingTop: '20px',
            }}
          />
          <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '6px', gridColumn: '1 / -1' }}>
            🚗 Курьер — один QR на всех
          </div>
          <p
            style={{
              fontSize: '12px',
              color: '#888',
              marginBottom: '16px',
              lineHeight: 1.45,
              gridColumn: '1 / -1',
            }}
          >
            Магического токена как у официанта в QR нет — только вход по паролю. Чтобы <strong>иконка на экране «Домой»</strong> открывала сразу логин, а не лендинг, курьер ставит PWA со страницы{' '}
            <a href="/pwa-courier" target="_blank" rel="noopener noreferrer" style={{ color: '#1565C0' }}>
              /pwa-courier
            </a>
            (один раз). Дальше — тот же email/пароль, что в списке выше. Один QR на бригаду.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gridColumn: '1 / -1' }}>
            <CourierLoginQRCard restaurantName={restaurantName} />
          </div>
        </div>

        {waiters.filter((w) => w.waiter_token).length === 0 && (
          <div style={{ textAlign: 'center', color: '#999', padding: '24px', fontSize: '14px' }}>
            Добавьте официантов — появятся QR-карточки
          </div>
        )}
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: '10px',
  border: '1px solid #E0E0E0',
  fontSize: '14px',
  boxSizing: 'border-box',
  outline: 'none',
};
const btnStyle = (bg) => ({
  padding: '10px 18px',
  borderRadius: '12px',
  border: 'none',
  backgroundColor: bg,
  color: '#fff',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
});
